export default [
  {
    path: "/historial-evaluaciones/:id_oferta_persona",
    name: "historial-evaluaciones",
    component: () =>
      import(
        /* webpackChunkName: "historialEvaluacionesCandidatos" */ "./views/HistorialEvaluaciones.vue"
      ),
  },
];
